module.exports = __webpack_public_path__ + "static/interface-3cc0ee43b53b48657395f3ba97b48e7e.svg";